import { Link } from "react-router";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background text-center px-4">
      <div className="bg-card rounded-lg shadow-sm border border-border p-8 md:p-12 max-w-md w-full">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="material-icons-outlined text-3xl text-primary">
            search_off
          </span>
        </div>
        <h2 className="text-3xl font-bold tracking-tight text-foreground">
          404
        </h2>
        <p className="mt-2 text-lg text-foreground-secondary">
          Page not found
        </p>
        <p className="mt-1 text-muted-foreground text-sm">
          Could not find the requested resource.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block rounded bg-primary px-6 py-3 text-sm font-bold text-primary-foreground shadow-sm hover:bg-primary-dark transition-all duration-base active:scale-[0.98]"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}
